import { render } from "./ProposalEmbedded.vue?vue&type=template&id=093e4432&scoped=true"
import script from "./ProposalEmbedded.vue?vue&type=script&lang=js"
export * from "./ProposalEmbedded.vue?vue&type=script&lang=js"

import "./ProposalEmbedded.vue?vue&type=style&index=0&id=093e4432&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-093e4432"]])

export default __exports__